import React from 'react';
import './SGBPage.css';
import SGBTable from './SGBTable';
import Learning from '../../Home/learning/Learning'
import { Container, Col, Row } from "react-bootstrap";
import AskFaq from "../../../Images/askFaq.png";
import Accordion from "react-bootstrap/Accordion";
import RBILogo from "../../../Images/SGB/sgb_RBI_LOGO.png";
import BannerLogo from "../../../Images/SGB/sgb_banner-coin.png";
import Goldbonds from "../../../Images/SGB/sgb_gold-bonds-1.png";
import BondLogo from "../../../Images/SGB/sgb_gold-bonds-2.png";
import SgbondLogo from "../../../Images/SGB/sgb_gold-bonds-3.png";
import SgbLogo from "../../../Images/SGB/sgb_gold-bonds-4.png";
import BondSgb from "../../../Images/SGB/sgb_gold-bonds-5.png";
import LogoSgb from "../../../Images/SGB/sgb_gold-bonds-6.png"
import sgbgreenline from "../../../Images/SGB/sgb_green-line.png"
import SgbWork from "../../../Images/SGB/sgb_work-1.png"
import GreenArrow from "../../../Images/SGB/sgb_green_arrow.png"
import redarrow from "../../../Images/SGB/sgb_red_arrow.png"
import WorkSgb from "../../../Images/SGB/sgb_work-2.png"
import GreenASgb from "../../../Images/SGB/sgb_green_arrow.png"
// import RedASgb from "../../../Images/SGB/ sgb_red_arrow.png"  
import WorkASgb from "../../../Images/SGB/sgb_work-3.png"
import RedLineASgb from "../../../Images/SGB/sgb_red-line.png"
import GoldInvest from "../../../Images/SGB/sgb_gold-invest-1.png"
import GoldASgb from "../../../Images/SGB/sgb_gold-invest-2.png"
import InvestASgb from "../../../Images/SGB/sgb_gold-invest-3.png"
import AgoldSgb from "../../../Images/SGB/sgb_gold-invest-4.png"
import AGInvestSgb from "../../../Images/SGB/sgb_gold-invest-5.png"
import GInveSgb from "../../../Images/SGB/sgb_gold-invest-6.png"
import GivestASgb from "../../../Images/SGB/sgb_gold-invest-7.png"
import InvesGoldSgb from "../../../Images/SGB/sgb_gold-invest-8.png"
import InvestmentSgb from "../../../Images/SGB/sgb_gold-investment-1.png"
import InvesldSgb from "../../../Images/SGB/sgb_gold-investment-2.png"
import nveoldSgb from "../../../Images/SGB/sgb_gold-investment-3.png"
import vesGolSgb from "../../../Images/SGB/sgb_gold-investment-4.png"
import inesGodSgb from "../../../Images/SGB/sgb_gold-investment-5.png"
import nvesGodSb from "../../../Images/SGB/sgb_gold-investment-6.png"
import startlearning from "../../../Images/SGB/sgb_start-learning.jpg"


function SGBPage() {
    return (
        <div className="sgb-main">

           
            <SGBTable />

            <section className="sgb_bond-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="section-heading">
                                What are Sovereign Gold Bonds
                            </h2>
                            <div className="gold-bond-container">
                                <div className="gold-bond-box">
                                    <div className="img-container">
                                        <img src={Goldbonds} alt="" />
                                    </div>
                                    <p>Alternative to physical Gold</p>
                                </div>
                                <div className="gold-bond-box">
                                    <div className="img-container">
                                        <img src={BondLogo} alt="" />
                                    </div>
                                    <p>Gold Bonds issued by RBI</p>
                                </div>
                                <div className="gold-bond-box">
                                    <div className="img-container">
                                        <img src={SgbondLogo} alt="" />
                                    </div>
                                    <p>Issued at gold's prevailing price</p>
                                </div>
                                <div className="gold-bond-box">
                                    <div className="img-container">
                                        <img src={SgbLogo} alt="" />
                                    </div>
                                    <p>Bonds listed on stock exchange post-issuance</p>
                                </div>
                                <div className="gold-bond-box">
                                    <div className="img-container">
                                        <img src={BondSgb} alt="" />
                                    </div>
                                    <p>Get 2.5% annual interest on investments</p>
                                </div>
                                <div className="gold-bond-box">
                                    <div className="img-container">
                                        <img src={LogoSgb} alt="" />
                                    </div>
                                    <p>Redeemed at gold's current price on maturity</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sgb_work-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="section-heading">
                                How it works
                            </h2>
                            <div className="section-heading-help-text">
                                Total amount returned at maturity
                            </div>

                            <div className="work-main-wrapper">
                                <div className="work-main-container">
                                    <div className="arrow-line text-center">
                                        <img src={sgbgreenline} alt="" />
                                    </div>
                                    <div className="work-container">
                                        <div className="work-box">
                                            <div className="img-container">
                                                <img src={SgbWork} alt="" />
                                            </div>
                                            <p>Investor</p>
                                        </div>
                                        <div className="arrow-box">
                                            <p>
                                                Matures in <br></br>
                                                8 years
                                            </p>
                                            <div className="inner-arrow-container">
                                                <div className="img-container">
                                                    <img src={GreenArrow} alt="" />
                                                </div>
                                                <div className="img-container">
                                                    <img src={redarrow} alt="" />
                                                </div>
                                            </div>

                                            <p>
                                                Allotted to <br></br>
                                                investors
                                            </p>
                                        </div>
                                        <div className="work-box">
                                            <div className="img-container">
                                                <img src={WorkSgb} alt="" />
                                            </div>
                                            <p>Gold Bond</p>
                                        </div>
                                        <div className="arrow-box">
                                            <p>
                                                Redeemed at current <br></br>
                                                gold price
                                            </p>
                                            <div className="inner-arrow-container">
                                                <div className="img-container">
                                                    <img src={GreenASgb} alt="" />
                                                </div>
                                                <div class="img-container">
                                            <img src={redarrow} alt=""/>
                                        </div>
                                            </div>
                                            <p>
                                                Issues gold bond <br></br>
                                                at spot price
                                            </p>
                                        </div>
                                        <div className="work-box">
                                            <div className="img-container">
                                                <img src={WorkASgb} alt="" />
                                            </div>
                                            <p>RBI</p>
                                        </div>
                                    </div>
                                    <div className="arrow-line red-line text-center">
                                        <img src={RedLineASgb} alt="" />
                                    </div>

                                </div>
                                <div className="intrest-rate">
                                    <ul>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="total-amount">
                                Total Investment amount
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sgb_comparison-section">
                <div className="container p-0">
                    <div className="row">
                        <div className="col-12 p-0">
                            <h2 className="section-heading">
                                SGB Comparison
                            </h2>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>PARTICULARS</th>
                                            <th>PHYSICAL GOLD</th>
                                            <th>DIGITAL GOLD​</th>
                                            <th>SOVEREIGN GOLD <br></br> BONDS​</th>
                                            <th>GOLD ETFS​</th>
                                            <th>GOLD MUTUAL FUNDS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Offered by</td>
                                            <td>
                                                Retail jewellers, <br></br>
                                                Banks</td>
                                            <td>
                                                MMTC-PAMP India, <br></br>
                                                Augmont Gold Ltd, <br></br>
                                                Digital Gold India
                                            </td>
                                            <td>Reserve Bank of India,
                                                Stock Exchanges</td>
                                            <td>Stock Exchanges</td>
                                            <td>Mutual Fund Houses,
                                                Distributors</td>
                                        </tr>
                                        <tr>
                                            <td>Investment <br></br>
                                                Limits</td>
                                            <td>No limit</td>
                                            <td>No limit</td>
                                            <td>For Individual & HUF -
                                                Min 1 gm of gold to Max
                                                of 4kg , 20kg for Trusts</td>
                                            <td>Min 1 unit and no
                                                upper limit</td>
                                            <td>Min amount of Rs. 100
                                                and no upper limit</td>
                                        </tr>
                                        <tr>
                                            <td>Returns</td>
                                            <td>No regular return
                                                on investment</td>
                                            <td>No regular return
                                                on investment</td>
                                            <td>Interest at 2.5% p.a.</td>
                                            <td>No regular return
                                                on investment</td>
                                            <td>No regular return
                                                on investment</td>
                                        </tr>
                                        <tr>
                                            <td>Taxation</td>
                                            <td>Before 3 years slab
                                                rate. After 3 years
                                                20% with indexation.</td>
                                            <td>Before 3 years slab
                                                rate. After 3 years
                                                20% with indexation.</td>
                                            <td>Tax free on maturity</td>
                                            <td>Slab rate</td>
                                            <td>Slab rate</td>
                                        </tr>
                                        <tr>
                                            <td>Costs</td>
                                            <td>Making Charges
                                                and Storage Costs </td>
                                            <td>3-6% spread of
                                                additional costs </td>
                                            <td>Negligible Costs</td>
                                            <td>Upto 1% Expense
                                                Ratio</td>
                                            <td>Upto 1% Expense
                                                Ratio</td>
                                        </tr>
                                        <tr>
                                            <td>Lock-in period</td>
                                            <td>No Lock-in</td>
                                            <td>No Lock-in</td>
                                            <td>Lock-in of 8 years
                                                (redemption window
                                                after 5 years)</td>
                                            <td>No Lock-in</td>
                                            <td>No Lock-in</td>
                                        </tr>
                                        <tr>
                                            <td>Tradability</td>
                                            <td>Not Tradable</td>
                                            <td>Not Tradable</td>
                                            <td>Tradable on
                                                Exchange</td>
                                            <td>Tradable on
                                                Exchange</td>
                                            <td>Not Tradable</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sgb_invest-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="section-heading">
                                Why Invest in Gold
                            </h2>
                            <div className="invest-container">
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={GoldInvest} alt="" />
                                    </div>
                                    <p>
                                        Portfolio <br></br>
                                        Diversification
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={GoldASgb} alt="" />
                                    </div>
                                    <p>
                                        Reliable hedge against
                                        inflation and economic
                                        instability
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={InvestASgb} alt="" />
                                    </div>
                                    <p>
                                        Store of <br></br>
                                        Value
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={AgoldSgb} alt="" />
                                    </div>
                                    <p>
                                        Inversely related to
                                        stock market
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={AGInvestSgb} alt="" />
                                    </div>
                                    <p>
                                        Tangible <br></br>
                                        Asset
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={GInveSgb} alt="" />
                                    </div>
                                    <p>
                                        Liquid <br></br>
                                        asset
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={GivestASgb} alt="" />
                                    </div>
                                    <p>
                                        Low/negative Correlation <br></br>
                                        to other Assets
                                    </p>
                                </div>
                                <div className="invest-box">
                                    <div className="img-container">
                                        <img src={InvesGoldSgb} alt="" />
                                    </div>
                                    <p>
                                        QE & B/S expansion
                                        by Central Banks
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sgb_best-invest-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="section-heading">
                                Why is Sovereign Gold Bonds the <br></br> best form of Gold investment
                            </h2>
                            <div className="best-invest-container">
                                <div className="best-invest-box">
                                    <span>
                                        <img src={InvestmentSgb} alt="" />
                                    </span>
                                    <div className="content">
                                        <div className="head">
                                            Fixed Interest
                                        </div>
                                        <p>RBI offers 2.5% Assured Interest p.a. on initial investment</p>
                                    </div>
                                </div>
                                <div className="best-invest-box">
                                    <span>
                                        <img src={InvesldSgb} alt="" />
                                    </span>
                                    <div className="content">
                                        <div className="head">
                                            Tax Advantage
                                        </div>
                                        <p>With No Capital Gain Tax if Held to Maturity* & No TDS on Interest</p>
                                    </div>
                                </div>
                                <div className="best-invest-box">
                                    <span>
                                        <img src={nveoldSgb} alt="" />
                                    </span>
                                    <div className="content">
                                        <div className="head">
                                            Sovereign Guarantee
                                        </div>
                                        <p>On Redemption Amount & Interest Payment</p>
                                    </div>
                                </div>
                                <div className="best-invest-box">
                                    <span>
                                        <img src={vesGolSgb} alt="" />
                                    </span>
                                    <div className="content">
                                        <div className="head">
                                            Collateral
                                        </div>
                                        <p>Bonds be used as collateral for loans</p>
                                    </div>
                                </div>
                                <div className="best-invest-box">
                                    <span>
                                        <img src={inesGodSgb} alt="" />
                                    </span>
                                    <div className="content">
                                        <div className="head">
                                            Storage Cost
                                        </div>
                                        <p>Liquidity</p>
                                    </div>
                                </div>
                                <div className="best-invest-box">
                                    <span>
                                        <img src={nvesGodSb} alt="" />
                                    </span>
                                    <div className="content">
                                        <div className="head">
                                            Liquidity
                                        </div>
                                        <p>Liquid as they are listed on exchange</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sgb_learning-section">
      
                <Learning />
                
            </section>

      
            <section className="faq-block faqsgb">
                <Container>
                    <Row>
                        <Col md={8}>
                            <h1>Frequently Asked Questions</h1>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        Q1.  What are Sovereign Gold Bonds (SGB) and who issue them?
                                    </Accordion.Header>
                                    <Accordion.Body className="textjustify">
                                        <p>
                                        SGBs are gold-denominated government securities issued by the Reserve Bank in digital form.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        Q2. What are the minimum and maximum limits for investing in SGB?
                                    </Accordion.Header>
                                    <Accordion.Body className="textjustify">
                                        <p> Bonds are issued in denominations of 1 gram of gold and in multiples thereof. 
                                            The minimum investment shall be one gram. The maximum limit for subscription shall be 4 kg for individuals,
                                             4 kg for Hindu Undivided Family (HUF), and 20 kg for trusts and similar entities per fiscal year, 
                                             as notified by the government from time to time.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        Q3. How will an investor receive acknowledgement of their investment in SGB?
                                    </Accordion.Header>
                                    <Accordion.Body className="textjustify">
                                        <p>
                                        SGB is issued in demat mode; customers receive a Certificate of Holding, sent to their email ID.
                                            {/* <a href="/Pricing" target="_blank">here</a>. */}
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        Q4. What is the interest rate for SGB, and how will it be paid?
                                    </Accordion.Header>
                                    <Accordion.Body className="textjustify">
                                        <p> The interest rate of 2.50% p.a. will be credited semiannually to the registered bank account,
                                             and the final interest will be repaid along with the principle at maturity.</p>
                                    
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        Q5. When will the SGB bonds be redeemed?
                                    </Accordion.Header>
                                    <Accordion.Body className="textjustify">
                                        <p>The maturity time for SGB bonds is 8 years; however, 
                                            premature redemption can be done from the 5th year onwards.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        Q6. Are there any risks to investing in SGBs?
                                    </Accordion.Header>
                                    <Accordion.Body className="textjustify">
                                        <p>If, at maturity, the market price of gold falls, there is a risk of capital loss. However,
                                             the investor does not lose the gold units that he has paid for.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                        <Col md={4}>
                            <div className="faq-beta">
                                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
                            </div>
                        </Col>
                    </Row>
                </Container>   
            </section>
        </div>
    )
}

export default SGBPage
